import {Mask, useMask} from '@react-three/drei'

export function SquareMask({id, ...props}) {
    return (
        <Mask id={id} {...props} colorWrite={false}>
            <planeGeometry args={[5.24, 11.31]}/>
            <meshBasicMaterial
                color='blue'
            />
        </Mask>
    )
}

export function MaskedScene({id, ...props}) {
    const stencil = useMask(id)

    return (
        <>
            <mesh {...props} >
                <sphereGeometry args={[1, 32, 32]}/>
                <meshBasicMaterial
                    color='orange'
                    {...stencil}
                />
            </mesh>
        </>
    )
}


